import { useEffect, useRef, useState } from "react";

export const Animation = ({
  path,
  loop = true,
  updatedPath
}: {
  path: string;
  loop?: boolean;
  updatedPath?: string;
}): JSX.Element => {
  const ref = useRef<HTMLDivElement>(null);
  const [lottie, setLottie] = useState(null);

  useEffect(() => {
    // @ts-ignore
    //We need to ignore the URL for webpack to work properly https://github.com/webpack/webpack/issues/8341
    import(/* webpackIgnore: true */ "https://cdn.skypack.dev/lottie-web").then(
      (Lottie) => {
        setLottie(Lottie.default);
      }
    );
  }, []);

  useEffect(() => {
    if (lottie && ref.current) {
      // @ts-ignore
      const animation = lottie.loadAnimation({
        container: ref.current,
        renderer: "svg",
        loop,
        autoplay: true,
        path
      });

      animation.onComplete = () => {
        if (updatedPath) {
          // @ts-ignore
          lottie.loadAnimation({
            container: ref.current,
            renderer: "svg",
            loop: true,
            autoplay: true,
            path: updatedPath
          });

          animation.destroy();
        }
      };

      return () => animation.destroy();
    }
  }, [lottie, path]);

  return <div ref={ref} />;
};
